import { i18n } from './globalize';
import ui from './ui';

const required = value => (value || value == '0') ? undefined : i18n.t('Validator_Required');
const requiredDate = value => (value || value == '0') ? undefined : i18n.t('Validator_RequiredDateInFormat', { dateFormat: ui.getLocaleDateFormat() });

const requiredArray = value => (value && value.length > 0) ? undefined : i18n.t('Validator_Required');

const minLength = min => value =>
	value && value.length < min ? i18n.t('Validator_MinLength', { min }) : undefined;

const maxLength = max => value =>
	value && value.length > max ? i18n.t('Validator_MaxLength', { max }) : undefined;

const number = value => value && isNaN(Number(value)) ? i18n.t('Validator_Number') : undefined;

const minValue = min => value =>
	value && value < min ? i18n.t('Validator_MinValue', { min }) : undefined;

const maxValue = max => value =>
	value && value > max ? i18n.t('Validator_MaxValue', { max }) : undefined;

const range = (min, max) => value =>
	value && (value < min || value > max) ? i18n.t('Validator_Range', { min, max }) : undefined;

const pattern = (regex, messageI18nKey) => value =>
	value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
		i18n.t(messageI18nKey || 'Validator_Pattern') : undefined;

const email = pattern(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, 'Validator_Email');

const dateInThePast = value => value && (value instanceof Date) && value > new Date() ? i18n.t('Validator_DateInThePast') : undefined;

export default {
	required,
	requiredDate,
	requiredArray,
	minLength,
	maxLength,
	number,
	minValue,
	maxValue,
	range,
	pattern,
	email,
	dateInThePast
};
